import React, { FunctionComponent, useMemo } from 'react';
import SolicitationsList from 'components/solicitations-list/solicitations-list';
import { useCurrentBilikZones } from 'context/current-bilik-zones-context';

const SolicitationsListPage: FunctionComponent = () => {
  const { currentBilikZones } = useCurrentBilikZones();

  const title: React.ReactElement = useMemo(
    () => (
      <>
        Demandes mail
        <small>
          {currentBilikZones
            ? currentBilikZones.map((zone) => zone.mainCityCode).join(', ')
            : 'Toutes les zones'}
        </small>
      </>
    ),
    [currentBilikZones],
  );

  return <SolicitationsList title={title} />;
};

export default SolicitationsListPage;
